/*
 * @Author: Tina Huang
 * @Date: 2024-02-19 10:09:47
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-08-16 12:03:52
 * @Description:
 */
type LOGS = {
  date: string
  author: string
  content: string
  icon: string
  type: string
  version: string
  link?: string | null
}

export const logs: LOGS[] = [
  {
    date: '2024/08/16',
    author: 'httishere',
    content: 'Fix: 修复优化部分问题',
    icon: 'el-icon-success',
    type: 'success',
    version: '3.1.2',
  },
  {
    date: '2024/07/12',
    author: 'httishere',
    content: 'Feat: <br><br>1. 增加模版搜索功能，帮助快速定位所需模版<br><br>2. 增加免费模版筛选勾选框，可一键查看所有免费模版',
    icon: 'el-icon-success',
    type: 'success',
    version: '3.1.1',
  },
  {
    date: '2024/04/23',
    author: 'httishere',
    content: 'Feat: 升级官网样式，打造个人品牌',
    icon: 'el-icon-success',
    type: 'success',
    version: '3.1.0',
  },
  {
    date: '2024/3/04',
    author: 'httishere',
    content: 'Feat: 重构组件库，取消组件入口口令',
    icon: 'el-icon-success',
    type: 'error',
    version: '3.0.0',
  },
  {
    date: '2024/01/11',
    author: 'httishere',
    content: 'Feat: 增加模版口令获取入口',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.3.2',
  },
  {
    date: '2023/07/28',
    author: 'httishere',
    content: 'Feat: 增加模版搜索',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.3.1',
  },
  {
    date: '2023/06/27',
    author: 'httishere',
    content: 'Feat: 手机端适配，可在手机端方便配置和复制组件链接',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.3.0',
  },
  {
    date: '2023/06/16',
    author: 'httishere',
    content: 'Feature: 开放永久会员渠道',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.2.0',
  },
  {
    date: '2023/04/23',
    author: 'httishere',
    content: '更新口令',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.1.0',
  },
  {
    date: '2023/03/07',
    author: 'httishere',
    content: 'Feature: 新增模版详情页，可查看模版介绍视频',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.1.0',
  },
  {
    date: '2023/03/02',
    author: 'httishere',
    content: 'Fix: 多项倒数日支持暗黑模式',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.5',
  },
  {
    date: '2023/01/28',
    author: 'httishere',
    content: 'Feat: 新增随机句子卡片组件',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.5',
  },
  {
    date: '2023/01/27',
    author: 'httishere',
    content: 'Feat: 新增区间进度条组件',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.5',
  },
  {
    date: '2023/01/10',
    author: 'httishere',
    content: 'Feat: 新增组件评论区',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.4',
  },
  {
    date: '2023/01/08',
    author: 'httishere',
    content: 'Feat: 新增范围日历组件',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.3',
  },
  {
    date: '2023/01/07',
    author: 'httishere',
    content: 'Feat: 新增快捷按钮组件',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.3',
  },
  {
    date: '2023/01/06',
    author: 'httishere',
    content: 'Feat: 优化组件库列表和获取方式，公开展示组件和模版内容',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.3',
  },
  {
    date: '2023/01/05',
    author: 'httishere',
    content: 'Feat: <br><br>1. 年度格子支持暗黑模式;<br><br>2. 新增Notion模版(年度计划);',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.2',
  },
  {
    date: '2023/01/02',
    author: 'httishere',
    content: 'Feat: <br><br>1. 重构访问方式(弹窗);<br><br>2. 新增Notion模版(每日打卡，年度复盘);',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.2',
  },
  {
    date: '2022/12/24',
    author: 'httishere',
    content: '补充范围日历。',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.1',
  },
  {
    date: '2022/12/22',
    author: 'httishere',
    content: '补充两个倒数日组件。',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.1',
  },
  {
    date: '2022/07/22',
    author: 'httishere',
    content:
      '组件库UI全面升级，简化使用操作<br><br>Feat:<br>1. UI升级<br>2. 新增多个组件<br>3. 新增多个Notion模版<br><br>Bugs:<br> 1. 组件参数造成的embed失败',
    icon: 'el-icon-success',
    type: 'success',
    version: '2.0.1',
  },
  {
    date: '2022/04/04',
    author: 'httishere',
    content: '部分组件支持周起始选择（周一/周日）',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.3',
  },
  {
    date: '2022/04/03',
    author: 'httishere',
    content: '图床修复，更新口令',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.3',
  },
  {
    date: '2022/01/12',
    author: 'httishere',
    content: '新增3个相关日历组件，优化文案空格问题。新增暗黑模式设置',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.2',
  },
  {
    date: '2022/01/07',
    author: 'httishere',
    content: '优化“人生进度条”，增加备注设置',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.2',
  },
  {
    date: '2022/01/06.2',
    author: 'httishere',
    content: 'HTT组件库正式上线！！',
    icon: 'el-icon-success',
    type: 'warning',
    version: '1.0.2',
  },
  {
    date: '2022/01/06',
    author: 'httishere',
    content: '新增组件：“日历卡片”，“人生进度条”和“电子桌面时钟”',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.2',
  },
  {
    date: '2022/01/05',
    author: 'httishere',
    content: '新增组件：“多项倒数日”',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.2',
  },
  {
    date: '2022/01/04',
    author: 'httishere',
    content: '新增组件：“时间进度条”和“周进度”',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.2',
  },
  {
    date: '2021/12/31',
    author: 'httishere',
    content: '新增组件：“历史上的今天”和“今日诗词”',
    icon: 'el-icon-success',
    type: 'success',
    version: '1.0.1',
  },
  {
    date: '2021/12/30',
    author: 'httishere',
    content: '基本组件汇总，动态时钟实现',
    icon: 'el-icon-success',
    type: 'success',
    link: null,
    version: '1.0.1',
  },
]
